<template>
  <v-main class="main-background">
    <overlay/>
    <router-view :key="$route.fullPath"/>

    <!--    <dashboard-core-footer />-->
  </v-main>
</template>

<script>
  import Overlay from '../../../../components/Overlay'

  export default {
    name: 'DashboardCoreView',
    components: { Overlay },
    // components: {
    //   DashboardCoreFooter: () => import('./Footer'),
    // },
  }
</script>
<style>
.main-background{
  background-color: #f4f6f9 !important;
}
</style>
